import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasNodeToolbarActionClicked.meta';

export type UseTrackCanvasNodeToolbarActionClickedParams = {
  canvas_id: string;
  node_type: 'image' | 'video';
  action_taken:
    | 'adjust_image'
    | 'camera_angle'
    | 'change_lighting'
    | 'smart_resize'
    | 'crop'
    | 'prompt'
    | 'flip_and_rotate'
    | 'erase'
    | 'extend_background'
    | 'remove_background'
    | 'upscale'
    | 'convert_to_gif';
};

export const useTrackCanvasNodeToolbarActionClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasNodeToolbarActionClicked = useCallback(
    (params: UseTrackCanvasNodeToolbarActionClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasNodeToolbarActionClicked };
};
